/* eslint-disable consistent-return,no-param-reassign */

import Progress from 'redux-progress';
import { produce } from 'immer';

import * as search from 'modules/change/search/duck/actions';
import * as actions from 'modules/change/table/duck/actions';
import { TableState } from 'modules/change/table/duck/model';

const initialState: TableState = {
  list: Progress.none,
  paginated: {},
  options: {},
  selected: {
    allAccounts: false,
    accounts: {},
    orderableItemIds: {},
    months: {},
  },
  progress: Progress.none,
  showFlag: false,
};

function handleLoadChangeList(draft: TableState, action: any) {
  draft.list = action.progress;
  action.progress.ifSuccess((overview: any) =>
    overview?.accounts?.forEach(({ accountId }: any) => {
      draft.selected.accounts[accountId] = false;
    }),
  );
}

function handleLoadPaginatedChangeList(draft: TableState, action: any) {
  draft.list = action.progress;
  action.progress.ifSuccess((overview: any) => {
    if (overview?.totalItems && !draft.paginated[`${overview?.offset}`]) {
      draft.paginated[`${overview.offset}`] = overview;
      overview.accounts.forEach(({ accountId }: any) => {
        draft.selected.accounts[accountId] = false;
      });
    }
  });
}

function handleToggleAccount(draft: TableState, action: any) {
  draft.selected.accounts[action.payload.accountId] =
    !draft.selected.accounts[action.payload.accountId];
  draft.selected.allAccounts = !Object.values(draft.selected.accounts).includes(false);
}

function handleToggleAllAccounts(draft: TableState) {
  draft.selected.allAccounts = !draft.selected.allAccounts;
  Object.keys(draft.selected.accounts).forEach((id) => {
    draft.selected.accounts[id] = draft.selected.allAccounts;
  });
}

function handlePickOption(draft: TableState, action: any) {
  draft.selected.orderableItemIds[action.payload.account.accountId] =
    action.payload.option.orderableItemId;
  draft.selected.months[action.payload.account.accountId] = action.payload.option.maintenanceMonths;
}

function handlePickTerm(draft: TableState, action: any) {
  draft.selected.months[action.payload.account.accountId] = action.payload.term.months;
}

function handleSubmitChangeList(draft: TableState, action: any) {
  draft.progress = action.progress;
  if (action.progress.isCompleted && action.progress.result?.errorKey) {
    draft.progress = Progress.fail(action.progress.result);
  }
}

function handleSelectForm(draft: TableState, action: any) {
  draft.selected.allAccounts = false;
  Object.keys(draft.selected.accounts).forEach((id) => {
    if (!action.payload.foundAccountsIds.includes(id)) {
      draft.selected.accounts[id] = false;
    }
  });

  draft.options[action.payload.account.accountId] = Progress.success({
    optionsList: action.payload.isSSSDisabled ? [] : action.payload.account.changeOptions,
    ineligibilityReason: action.payload.account.ineligibilityReason,
  });
}

function handleResetForm(draft: TableState) {
  draft.selected.allAccounts = false;
  Object.keys(draft.selected.accounts).forEach((id) => {
    draft.selected.accounts[id] = false;
  });
  draft.options = {};
}

function handleFetchAccountChangeOptions(draft: TableState, action: any) {
  draft.options[action.payload.accountId] = action.progress.map(
    ({ accounts }: any) =>
      accounts &&
      accounts.length > 0 && {
        optionsList: action.payload.isSSSDisabled ? [] : accounts[0].changeOptions,
        ineligibilityReason: accounts[0].ineligibilityReason,
      },
  );
}

export default produce((draft: TableState, action): TableState | void => {
  switch (action.type) {
    case actions.LOAD_CHANGE_LIST:
      handleLoadChangeList(draft, action);
      break;
    case actions.LOAD_PAGINATED_CHANGE_LIST:
      handleLoadPaginatedChangeList(draft, action);
      break;
    case actions.TOGGLE_ACCOUNT:
      handleToggleAccount(draft, action);
      break;
    case actions.TOGGLE_ALL_ACCOUNTS:
      handleToggleAllAccounts(draft);
      break;
    case actions.PICK_OPTION:
      handlePickOption(draft, action);
      break;
    case actions.PICK_TERM:
      handlePickTerm(draft, action);
      break;
    case actions.SUBMIT_CHANGE_LIST:
      handleSubmitChangeList(draft, action);
      break;
    case search.SELECT_FORM:
      handleSelectForm(draft, action);
      break;
    case search.RESET_FORM:
      handleResetForm(draft);
      break;
    case actions.RESET_CHANGE_LIST:
      return initialState;
    case actions.FETCH_ACCOUNT_CHANGE_OPTIONS:
      handleFetchAccountChangeOptions(draft, action);
      break;
    default:
      break;
  }
}, initialState);
